module.exports = __webpack_public_path__ + "static/media/dsp_background_tl.139a1911.png";